import React, { useEffect } from 'react';
import { useLangStore, dirFor } from '@/stores/langStore';

/**
 * Applies the current UI language to the document root (`lang` + `dir`) so the
 * whole unified staff portal mirrors to RTL when Hebrew is selected (ADR-012
 * i18n unification). admin-portal previously had no i18n; this is the single
 * app-wide direction switch. Renders nothing.
 */
export const LangDirection: React.FC = () => {
  const lang = useLangStore((s) => s.lang);
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dirFor(lang);
  }, [lang]);
  return null;
};
